import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import VendorHeader from "./../component/VendorHeader";
import VendorFooter from "./../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";

const icon1 = require("./../assets/img/dashboard-icon.svg").default;
const icon2 = require("./../assets/img/info-icon.svg").default;
const icon3 = require("./../assets/img/app-icon.svg").default;
const icon4 = require("./../assets/img/payment-icon.svg").default;
const icon5 = require("./../assets/img/store-icon.svg").default;
const icon6 = require("./../assets/img/list-icon.svg").default;
const icon7 = require("./../assets/img/order-icon.svg").default;
const icon8 = require("./../assets/img/plan-icon.svg").default;
const icon9 = require("./../assets/img/logout-icon.svg").default;
const deleteIcon = require("./../assets/img/delete-icon.svg").default;

const AddVideos = () => {
  const { user, storeData } = useAuth();
  const navigate = useNavigate();
  const { selectedLanguage, langJson } = useLanguage();
  const imageBtnRef = useRef();
  const videoBtnRef = useRef();
  const thumbnailBtnRef = useRef();

  const [addFormData, setAddFormData] = useState({
    title: null,
    description: null,
    url: null,
  });
  const [signupStatus, setSignupStatus] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [videoError, setVideoError] = useState("");
  const [thumbnailError, setThumbnailError] = useState("");
  const [loading, setLoading] = useState();
  const [addBtnDis, setAddBtnDis] = useState();
  const [uploadType, setUploadType] = useState("youtube"); // 'youtube' or 'upload'
  const allowedVideoExtensions = ["mp4", "webm", "mov", "avi", "mkv"];

  const handleChange = event => {
    const { name, value } = event.target;

    setAddFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleVideoFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const ext = file.name.split(".").pop().toLowerCase();
      const maxSize = 50 * 1024 * 1024; // 50MB

      if (!allowedVideoExtensions.includes(ext)) {
        setVideoError("Invalid video format. Allowed: MP4, WebM, MOV, AVI, MKV");
        setVideoFile(null);
      } else if (file.size > maxSize) {
        setVideoError("Video size must be less than 50MB");
        setVideoFile(null);
      } else {
        setVideoFile(file);
        setVideoError("");
      }
    }
  };

  const handleVideoDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      const ext = file.name.split(".").pop().toLowerCase();
      const maxSize = 50 * 1024 * 1024;

      if (!allowedVideoExtensions.includes(ext)) {
        setVideoError("Invalid video format. Allowed: MP4, WebM, MOV, AVI, MKV");
        setVideoFile(null);
      } else if (file.size > maxSize) {
        setVideoError("Video size must be less than 50MB");
        setVideoFile(null);
      } else {
        setVideoFile(file);
        setVideoError("");
      }
    }
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const ext = file.name.split(".").pop().toLowerCase();
      const allowedFormats = ["jpg", "jpeg", "png", "webp"];
      const maxSize = 5 * 1024 * 1024; // 5MB

      if (!allowedFormats.includes(ext)) {
        setThumbnailError("Invalid image format. Allowed: JPG, PNG, WebP");
        setThumbnailFile(null);
      } else if (file.size > maxSize) {
        setThumbnailError("Thumbnail size must be less than 5MB");
        setThumbnailFile(null);
      } else {
        setThumbnailFile(file);
        setThumbnailError("");
      }
    }
  };

  const handleRemoveVideo = () => {
    setVideoFile(null);
    setVideoError("");
  };

  const handleRemoveThumbnail = () => {
    setThumbnailFile(null);
    setThumbnailError("");
  };

  const onPostArticle = async () => {
    if (storeData?.active_plan === 1 && storeData?.total_videos >= 5) {
      NotificationManager.warning(langJson?.plan_limit_videos || "Free plan limited to 5 videos. Upgrade to Pro to add more.");
      return;
    }

    // Validation
    if (!addFormData.title || addFormData.title.trim() === "") {
      setSignupStatus(langJson?.titleisrequired || "Title is required");
      return;
    }

    if (uploadType === "youtube") {
      if (!addFormData.url || addFormData.url.trim() === "") {
        setSignupStatus(langJson?.urlisrequired || "YouTube URL is required");
        return;
      }
    } else {
      if (!videoFile) {
        setSignupStatus("Video file is required");
        return;
      }
    }

    setAddBtnDis(true);
    setSignupStatus("");
    const fd = new FormData();
    fd.append("title", addFormData.title);
    fd.append("description", addFormData.description || "");
    fd.append("lang", selectedLanguage);

    if (uploadType === "youtube") {
      fd.append("url", addFormData.url);
    } else {
      fd.append("video", videoFile);
      if (thumbnailFile) {
        fd.append("thumbnail", thumbnailFile);
      }
    }

    try {
      const response = await fetch(`${API_BASE_URL}stores/videos`, {
        method: "POST",
        body: fd,
        headers: {
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setSignupStatus(responseData.msg);
        setAddBtnDis(false);
        navigate("/vendor-videos");
      } else {
        setSignupStatus(responseData.msg);
        setAddBtnDis(false);
      }
    } catch (error) {
      console.error("Error during video upload:", error);
      setSignupStatus("Error uploading video. Please try again.");
      setAddBtnDis(false);
    }
  };

  useEffect(() => {
    setAddFormData({
      title: null,
      url: null,
    });
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
        <div className="rightSide">
          <h2>
            {langJson?.add} {langJson?.videos}
          </h2>
          <ul className="addAddress">
            <li>
              <label>{langJson?.title}</label>
              <input type="text" name="title" onChange={handleChange} value={addFormData.title || ""} />
            </li>

            {/* <li>
              <label>Description (Optional)</label>
              <textarea
                name="description"
                onChange={handleChange}
                value={addFormData.description || ""}
                rows="4"
              />
            </li> */}

            <li className="fullWidth">
              <label>Video Source</label>

              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="uploadType"
                  value="youtube"
                  checked={uploadType === "youtube"}
                  onChange={(e) => setUploadType(e.target.value)}
                />
                YouTube URL
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="uploadType"
                  value="upload"
                  checked={uploadType === "upload"}
                  onChange={(e) => setUploadType(e.target.value)}
                />
                Upload Video
              </label>
            </li>

            {uploadType === "youtube" ? (
              <li>
                <label>{langJson?.youtubevideourl}</label>
                <input type="text" name="url" onChange={handleChange} value={addFormData.url || ""} placeholder="https://youtube.com/watch?v=..." />
              </li>
            ) : (
              <>
                <li className="fullWidth">
                  <label>{langJson?.uploadvideos || "Upload Video"}:</label>
                  {videoError && <span className="lgnStatus">{videoError}</span>}
                  <br />
                  <input
                    type="file"
                    ref={videoBtnRef}
                    hidden
                    onChange={handleVideoFileChange}
                    accept=".mp4,.webm,.mov,.avi,.mkv"
                  />
                  <button type="button" onClick={() => videoBtnRef.current.click()}>
                    {langJson?.uploadvideo || "Choose video"}
                  </button>
                  <div
                    className="uploadFle"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={handleVideoDrop}
                  >
                    {!videoFile && (
                      <span className="uploadFleHint">{langJson?.dragdropvideo || "Drag & drop video files"}</span>
                    )}
                    {videoFile && (
                      <div className="uploadThumbItem">
                        <div className="uploadVideoThumb">
                          <span>📹</span>
                          <p>{videoFile.name.substring(0, 30)}</p>
                        </div>
                        <img
                          className="uploadThumbDelete"
                          src={deleteIcon}
                          alt="remove"
                          onClick={handleRemoveVideo}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    )}
                  </div>
                </li>

                <li className="fullWidth">
                  <label>Thumbnail (Optional)</label>
                  {thumbnailError && <span className="lgnStatus">{thumbnailError}</span>}
                  <br />
                  <input
                    type="file"
                    ref={thumbnailBtnRef}
                    hidden
                    onChange={handleThumbnailChange}
                    accept=".jpg,.jpeg,.png,.webp"
                  />
                  <button type="button" onClick={() => thumbnailBtnRef.current.click()}>
                    Choose Thumbnail
                  </button>
                  <div style={{ marginTop: '10px' }}>
                    {!thumbnailFile && <span style={{ color: '#999', fontSize: '12px' }}>Optional: Upload a custom thumbnail image</span>}
                    {thumbnailFile && (
                      <div className="uploadThumbItem">
                        <img
                          src={URL.createObjectURL(thumbnailFile)}
                          alt="thumbnail"
                          style={{ width: '120px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
                        />
                        <img
                          className="uploadThumbDelete"
                          src={deleteIcon}
                          alt="remove"
                          onClick={handleRemoveThumbnail}
                          style={{ cursor: 'pointer', marginLeft: '10px' }}
                        />
                      </div>
                    )}
                  </div>
                </li>
              </>
            )}

            <li className="fullWidth saveBtn">
              <button type="button" disabled={addBtnDis} onClick={() => onPostArticle()}>
                {addBtnDis ? langJson?.pleasewait : langJson?.savechanges}
              </button>
            </li>
            <span className="lgnStatus">{signupStatus}</span>
          </ul>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default AddVideos;
